/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Tenant creation data
 * @export
 * @interface CreateTenantRequest
 */
export interface CreateTenantRequest {
    /**
     * Tenant display name / organization name
     * @type {string}
     * @memberof CreateTenantRequest
     */
    name?: string;
    /**
     * Optional slug; will be derived from name if omitted
     * @type {string}
     * @memberof CreateTenantRequest
     */
    slug?: string;
    /**
     * Optional customer ID to create tenant under an existing customer (backoffice)
     * @type {string}
     * @memberof CreateTenantRequest
     */
    customerId?: string;
    /**
     * Optional settings map. Supported keys include: 
     * - skipEnrollment (boolean): when true, treat as backoffice create and skip self-service enrollment.
     * - autoCreateAdminUser (boolean): when true, if the customer's primary contact is not yet a user, automatically create a local admin user and assign TENANT_ADMIN.
     * - organization_name (string): organization name to persist in tenant settings; defaults to `name`.
     * @type {{ [key: string]: any; }}
     * @memberof CreateTenantRequest
     */
    settings?: { [key: string]: any; };
}

/**
 * Check if a given object implements the CreateTenantRequest interface.
 */
export function instanceOfCreateTenantRequest(value: object): value is CreateTenantRequest {
    return true;
}

export function CreateTenantRequestFromJSON(json: any): CreateTenantRequest {
    return CreateTenantRequestFromJSONTyped(json, false);
}

export function CreateTenantRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateTenantRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'slug': json['slug'] == null ? undefined : json['slug'],
        'customerId': json['customerId'] == null ? undefined : json['customerId'],
        'settings': json['settings'] == null ? undefined : json['settings'],
    };
}

export function CreateTenantRequestToJSON(json: any): CreateTenantRequest {
    return CreateTenantRequestToJSONTyped(json, false);
}

export function CreateTenantRequestToJSONTyped(value?: CreateTenantRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'slug': value['slug'],
        'customerId': value['customerId'],
        'settings': value['settings'],
    };
}

